import React, { useState } from "react";
import { Container, Box, TextField, Button, Typography } from "@mui/material";
import { Post_Question_To_CurtAI } from "../api/Post_Question_To_CurtAI";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import { Post_Question_To_CurtAI_Functioned } from "../api/Post_Question_To_CurtAI_Functioned";
import { Post_Question_To_CurtAI_Simple } from "../api/Post_Question_To_CurtAI_Simple";

function CurtAI() {
  const { logout } = StaffuseAuth();

  const [str_TypedQuestion, setstr_TypedQuestion] = useState("");
  const [str_Answer, setstr_Answer] = useState("");

  function handleType(e) {
    setstr_TypedQuestion(e.target.value);
  }

  function handleSubmitFunctioned(e) {
    console.log(str_TypedQuestion);
    Post_Question_To_CurtAI_Functioned(
      str_TypedQuestion,
      setstr_Answer,
      logout
    );
  }

  function handleSubmitSimple(e) {
    console.log(str_TypedQuestion);
    Post_Question_To_CurtAI_Simple(str_TypedQuestion, setstr_Answer, logout);
  }

  return (
    <>
      <Container
        maxWidth="sm"
        sx={{
          mt: 4,
          background: "linear-gradient(135deg, #1f1f1f, #2a2a2a)",
          borderRadius: "16px",
          boxShadow: "0 0 20px rgba(0, 255, 255, 0.5)",
          p: 4,
          fontFamily: "'Orbitron', sans-serif",
        }}
      >
        <Box sx={{ mb: 2 }}>
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              textAlign: "center",
              color: "#00ffff",
              textShadow: "0 0 5px #00ffff, 0 0 20px #00ffff",
            }}
          >
            CurtAI
          </Typography>
          <Box
            id="chat-area"
            sx={{
              minHeight: "300px",
              border: "1px solid #00ffff",
              borderRadius: "8px",
              p: 2,
              mb: 2,
              background: "rgba(0, 0, 0, 0.8)",
              color: "#fff",
              overflowY: "auto",
              boxShadow: "0 0 10px rgba(0, 255, 255, 0.5)",
            }}
          >
            {str_Answer || (
              <Typography
                variant="body1"
                sx={{ color: "#888", textAlign: "center" }}
              >
                Your answers will appear here...
              </Typography>
            )}
          </Box>
        </Box>
        <Box
          component="form"
          className="submit-form"
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <TextField
            name="input"
            id="input"
            label="Type your message"
            multiline
            rows={3}
            variant="outlined"
            fullWidth
            onChange={(e) => handleType(e)}
            value={str_TypedQuestion}
            sx={{
              background: "rgba(0, 0, 0, 0.8)",
              borderRadius: "8px",
              "& .MuiInputBase-input": {
                color: "#fff", // Ensures the text color is white
              },
              "& .MuiInputLabel-root": {
                color: "#00ffff", // Label color
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#00ffff",
                },
                "&:hover fieldset": {
                  borderColor: "#00ffff",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#00ffff",
                },
              },
            }}
          />
          <Button
            id="btn"
            variant="contained"
            color="primary"
            onClick={(e) => handleSubmitSimple(e)}
            sx={{
              background: "linear-gradient(90deg, #00ffff, #0077ff)",
              color: "#000",
              fontWeight: "bold",
              textShadow: "0 0 5px #00ffff",
              "&:hover": {
                background: "linear-gradient(90deg, #0077ff, #00ffff)",
                boxShadow: "0 0 15px #00ffff",
              },
            }}
          >
            Submit Simple
          </Button>
          <Button
            id="btn"
            variant="contained"
            color="primary"
            onClick={(e) => handleSubmitFunctioned(e)}
            sx={{
              background: "linear-gradient(90deg, #00ffff, #0077ff)",
              color: "#000",
              fontWeight: "bold",
              textShadow: "0 0 5px #00ffff",
              "&:hover": {
                background: "linear-gradient(90deg, #0077ff, #00ffff)",
                boxShadow: "0 0 15px #00ffff",
              },
            }}
          >
            Submit Functioned
          </Button>
        </Box>
      </Container>
    </>
  );
}

export default CurtAI;
